import i18n from 'services/base/i18n';

export default {
  title: (address: string, device: string) => i18n.sprintf(
    i18n.pgettext('Issues|Malicious Address', 'Blocked malicious address (%1$s) for %2$s.'),
    address, device,
  ),

  description: (address: string, device: string) => i18n.sprintf(
    i18n.pgettext('Issues|Malicious Address', 'Traffic to/from a listed malicious address (%1$s) has been blocked by Pangolin from communicating with %2$s.'),
    address, device,
  ),

  kindTitle:        () => i18n.pgettext('Issues|Malicious Address|Kind', 'Malicious Address Access'),
  kindSubtitle:     () => i18n.pgettext('Issues|Malicious Address|Kind', 'Phishing / Malvertising / Hacked Sites'),

  actionValueAllow: () => i18n.pgettext('Issues|Malicious Address|Action', 'Allow'),
  actionValueBlock: () => i18n.pgettext('Issues|Malicious Address|Action', 'Block'),

  actionLabelAllow: () => i18n.pgettext('Issues|Malicious Address|Action', 'Allow traffic between host and address'),
  actionLabelBlock: () => i18n.pgettext('Issues|Malicious Address|Action', 'Block traffic between host and address'),
};
